var map = {
	"./map1_relation.jpg": "Puv/",
	"./map2_relation.jpg": "aO1d",
	"./map3_relation.jpg": "vUzK",
	"./map4_relation.jpg": "5JeJ",
	"./map5_relation.jpg": "/dnd",
	"./map6_relation.jpg": "NoFK",
	"./map7_relation.jpg": "zN5b",
	"./map8_relation.jpg": "qOIi"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8lzi";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ^\.\/map.*_relation\.jpg$
// module id = 8lzi
// module chunks = 1